module.exports = __webpack_public_path__ + "static/media/ws.405a2c5f.svg";